(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  const seen = new WeakSet();
  const prepare = async card => {
    const image = card.querySelector('.revarta-hover-crossfade__image img');
    if (!image) return;
    image.loading = 'eager';
    try {
      await image.decode();
      if (image.naturalWidth > 0 && card.isConnected) card.classList.add('revarta-hover-ready');
    } catch {}
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      prepare(entry.target);
    }
  }, { rootMargin: '240px 0px' });
  const register = root => {
    const cards = [...root.querySelectorAll('.revarta-hover-crossfade')];
    if (root.matches?.('.revarta-hover-crossfade')) cards.push(root);
    for (const card of cards) {
      if (seen.has(card)) continue;
      seen.add(card);
      observer.observe(card);
      card.addEventListener('pointerenter', () => prepare(card), { once: true });
    }
  };
  register(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element) register(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
